import { Component, OnInit, Inject, ViewChild, ElementRef } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UtilitesService } from "app/base-module/base-service/utilites.service";
import { AuthService } from "app/base-module/base-service/auth.service";
import { BaseComponent } from "app/base-module/base-component/base.component";
import { PastaService } from "../services/pasta.service";
import { ArquivoService } from "../services/arquivo.service";
import { UsuarioService } from "app/base-module/base-service/usuario.service";
import { RolesService } from "app/usuarios/services/roles.service";
import { FormControl } from "@angular/forms";
import { EscritorioService } from "app/empreendimento/services/escritorio.service";

export interface DialogData {
    pasta_id: number;
}

@Component({
    selector: "app-upload-file",
    templateUrl: "./upload-file.component.html",
    styleUrls: ["./upload-file.component.scss"],
    providers: [ EscritorioService, RolesService ]
})

export class UploadFileComponent extends BaseComponent implements OnInit {
    @ViewChild("fileInput") fileInput!: ElementRef;
    users  = new FormControl();

    file:any;
    nomeFile:string | null;
    loadingLocal: any;
    listaGrupo: any[]=[];
    listaUsuario: any[]=[];    
    listaEscritorio: any[]=[];    
    selectedOptions=[];
    selectedOptionsEscritorio=[];
    selectedOption:any;
    usuario:any;
    formData = new FormData();

  constructor(
    public dialog: MatDialog,
    override snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<UploadFileComponent>,
    public service: PastaService,
    public utiliesService:UtilitesService,
    public arquivoService:ArquivoService,
    public authService: AuthService,
    public userService: UsuarioService,
    public roleService: RolesService,
    private _authService: AuthService,
    private _escritoService: EscritorioService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {

    super(dialog, snackBar);
    this.nomeFile = null;    

    const strUser = this._authService.getUser();
    this.usuario = JSON.parse(strUser? strUser : "{}");

    this.getAllGrupos();
    this.getAllUsuario();
    this.getAllEscritorios();
  }

    ngOnInit() {}

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    onChangeUser(){       
        this.formData.append("user", this.users.value);
    }

    onNgModelChange($event:any){
        this.formData.append("role_id", $event);
    }

    onNgModelChangeEscritorio($event:any){
        this.formData.append("escritorio_id", $event);
    }

    uploadFile(event:any) {    //line 1
        const file = event.target.files[0];
        if (file) {
            this.file = file;
            this.nomeFile = file.name;
        }
        this.formData.append("file", this.file);
    }

    isNomeFile(){
        return (this.nomeFile != null);
    }

    getAllGrupos(): void {    
        this.roleService.getAll({no_paginate:true}).subscribe(
            data => {
                this.listaGrupo = data.data;
            },
            error => {
                console.log("error: " + error);
                this.loadingIndicator = false;
            },
            () => {
                this.loadingIndicator = false;
            }
        );
    }

    getAllUsuario(): void {    
        this.userService.getAllUsuarios({no_paginate:true}).subscribe(
            data => {                
                this.listaUsuario = data;
            },
            error => {
                console.log("error: " + error);
                this.loadingIndicator = false;
            },
            () => {
                this.loadingIndicator = false;
            }
        );
    }
    
    getAllEscritorios(): void {
        this._escritoService.getTodos({no_paginate: true}).subscribe(
            data => {
                this.listaEscritorio = data.data;
            },
            error => {
                console.log("error: " + error);                
            },
            () => {
                console.log("complete");                
            }
        );
    }

    removerArquivo(): void {
        this.file = null;
        this.nomeFile = null;
        if (this.fileInput && this.fileInput.nativeElement) {
            this.fileInput.nativeElement.value = ""; // Limpa o input
        }
    }
    

    startUpload() {
        this.openLoading();

        this.formData.append("pasta_id" , String(this.data.pasta_id));

        this.arquivoService.upload(this.formData).subscribe(
            (data) => {
                this.showSuccess("Arquivo(s) anexado(s) com sucesso.");
                this.closeLoading();
                this.dialogRef.close(data);
            },
            (error) => {
                this.closeLoading();
                this.showError(error.error.message);
            },
            () => {
                this.closeLoading();
            }
        );
    }

}
